import React from 'react';
import Reservation from './Reservation';

export default function Noel() {
  return <Reservation preselectedSlug="mini-noel-2026"/>;
}